module.exports = __webpack_public_path__ + "static/media/Draft Icon.5c92eae1.svg";